<template>
  <div id="wrapper">
    <template-header/>

    <template-sidebar/>

    <div id="page-wrapper">
      <div class="page-content">
        <transition name="page-fade" mode="out-in" appear>
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateHeader from './MainTemplateHeader'
import TemplateSidebar from './MainTemplateSidebar'

export default {
  components: {
    TemplateHeader,
    TemplateSidebar
  },

  mounted () {
    window.$('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    })
  }
}
</script>
